<template>
    <div class="historyData-container">
        <h1>历史数据推荐</h1>
        <div class="filters">
            <el-row :gutter="20" style="margin-bottom: 20px;">
                <el-col :span="24">
                    <div class="filter-group">
                        <label>彩票类型: </label>
                        <el-select 
                            v-model="lotteryType" 
                            placeholder="请选择彩票类型"
                            @change="handleLotteryTypeChange"
                            style="width: 100%"
                        >
                            <el-option label="双色球" value="ssq"></el-option>
                            <el-option label="大乐透" value="dlt"></el-option>
                            <el-option label="福彩3D" value="fc3d"></el-option>
                        </el-select>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="filter-group">
                    <label>热号个数: </label>
                    <el-input 
                        v-model="filters.hot_count"
                        type="text"
                        :placeholder="`请输入${lotteryType === 'fc3d' ? '0-3' : (lotteryType === 'dlt' ? '0-5' : '0-6')}`"
                        @input="(val) => handleInput(val, 'hot_count')"
                    ></el-input>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="filter-group">
                    <label>冷号个数: </label>
                    <el-input 
                        v-model="filters.cold_count" 
                        :placeholder="`请输入${lotteryType === 'fc3d' ? '0-3' : (lotteryType === 'dlt' ? '0-5' : '0-6')}`"
                        @input="(val) => handleInput(val, 'cold_count')"
                        type="text"
                    ></el-input>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="filter-group">
                    <label>温号个数: </label>
                    <el-input 
                        v-model="filters.warm_count" 
                        :placeholder="`请输入${lotteryType === 'fc3d' ? '0-3' : (lotteryType === 'dlt' ? '0-5' : '0-6')}`"
                        @input="(val) => handleInput(val, 'warm_count')"
                        type="text"
                    ></el-input>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="filter-group">
                        <label>和值: </label>
                        <div style="display: flex;justify-content: space-between;align-items:center;width: 100%;">
                            <el-input 
                            v-model="filters.sum_range[0]" 
                            placeholder="最小值" 
                            style="width: 45%"
                            type="number"
                            ></el-input>
                            <span> 至 </span>
                            <el-input 
                                v-model="filters.sum_range[1]" 
                                placeholder="最大值" 
                                style="width: 45%"
                                type="number"
                            ></el-input>
                        </div>
                    </div>
                </el-col>
            </el-row>
            
            <el-row :gutter="20" style="margin-top: 20px;">
                <el-col :span="6">
                    <div class="filter-group">
                        <label>奇偶比: </label>
                        <el-select style="width: 100%;" v-model="filters.odd_even_ratio" placeholder="请选择奇偶比">
                            <el-option v-for="ratio in currentOddEvenRatios" :label="ratio" :key="ratio" :value="ratio"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="filter-group">
                        <label>大小比: </label>
                        <el-select style="width: 100%;" v-model="filters.high_low_ratio" placeholder="请选择大小比">
                            <el-option v-for="ratio in currentBigSmallRatios" :label="ratio" :key="ratio" :value="ratio"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="filter-group">
                    <label>连号数量: </label>
                    <el-input 
                        v-model="filters.consecutive_count" 
                        placeholder="请输入"
                        type="text"
                    ></el-input>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="filter-group">
                    <label>相同尾数数量: </label>
                    <el-input 
                        v-model="filters.same_tail_count" 
                        placeholder="请输入"
                        type="text"
                    ></el-input>
                    </div>
                </el-col>
            </el-row>
    
            <div class="filter-actions" style="margin: 20px 0;">
            <el-button type="danger" @click="applyFilters">推荐号码</el-button>
            <el-button type="danger" plain @click="resetFilters">重置条件</el-button>
            </div>
        </div>

        <div class="result-area" v-if="Object.keys(currentNumbers).length > 0">
            <el-card class="result-card">
                <div slot="header" class="clearfix">
                <span>推荐号码</span>
                </div>
                <span class="red-balls">
                    <span 
                    v-for="(ball, ballIndex) in Object.keys(currentNumbers)" 
                    :key="`combo-red-${ballIndex}`" 
                    class="ball red small"
                    >
                    {{ ball }}
                    </span>
                </span>
            </el-card>
        </div>
    </div>
</template>
<script>
import { getRecommendNum } from '../../api/tool'
export default {
    data() {
        return {
            lotteryType: 'ssq',
            ssqOddEvenRatios: ['0:6', '1:5', '2:4', '3:3', '4:2', '5:1', '6:0'],
            ssqBigSmallRatios: ['0:6', '1:5', '2:4', '3:3', '4:2', '5:1', '6:0'],
            dltOddEvenRatios: ['0:5', '1:4', '2:3', '3:2', '4:1', '5:0'],
            dltBigSmallRatios: ['0:5', '1:4', '2:3', '3:2', '4:1', '5:0'],
            fc3dOddEvenRatios: ['0:3', '1:2', '2:1', '3:0'],
            fc3dBigSmallRatios: ['0:3', '1:2', '2:1', '3:0'],
            currentOddEvenRatios: [],
            currentBigSmallRatios: [],
            filters: {
                hot_count: null,
                cold_count: null,
                warm_count: null,
                sum_range: [],
                odd_even_ratio: '',
                high_low_ratio: '',
                consecutive_count: '',
                same_tail_count:''
            },
            currentNumbers:[]
        }
    },
    created() {
        this.currentOddEvenRatios = this.ssqOddEvenRatios;
        this.currentBigSmallRatios = this.ssqBigSmallRatios;
    },
    methods: {
        handleLotteryTypeChange() {
            this.resetFilters();
            this.updatePlaceholders();
            switch(this.lotteryType) {
                case 'ssq':
                    this.currentOddEvenRatios = this.ssqOddEvenRatios;
                    this.currentBigSmallRatios = this.ssqBigSmallRatios;
                    break;
                case 'dlt':
                    this.currentOddEvenRatios = this.dltOddEvenRatios;
                    this.currentBigSmallRatios = this.dltBigSmallRatios;
                    break;
                case 'fc3d':
                    this.currentOddEvenRatios = this.fc3dOddEvenRatios;
                    this.currentBigSmallRatios = this.fc3dBigSmallRatios;
                    break;
            }
        },
        handleInput(value, field) {
            const cleanedValue = value.replace(/[^\d]/g, '');
            if (cleanedValue === '') {
                this.filters[field] = null;
                return;
            }
            const num = Number(cleanedValue);
            let maxValue = 6;
            switch(this.lotteryType) {
                case 'dlt':
                    maxValue = 5;
                    break;
                case 'fc3d':
                    maxValue = 3;
                    break;
            }

            if (num > maxValue) {
                this.$message.warning(`最大值为${maxValue}！`);
                this.filters[field] = maxValue;
            } else if (num < (this.lotteryType === 'fc3d' ? 0 : 1)) {
                this.$message.warning(`最小值为${this.lotteryType === 'fc3d' ? 0 : 1}！`);
                this.filters[field] = this.lotteryType === 'fc3d' ? 0 : 1;
            } else {
                this.filters[field] = num;
            }
        },
        updatePlaceholders() {
            let maxValue = 6;
            let minValue = 0;
            switch(this.lotteryType) {
                case 'dlt':
                    maxValue = 5;
                    break;
                case 'fc3d':
                    maxValue = 3;
                    minValue = 0;
                    break;
            }
            this.$nextTick(() => {
                const inputs = document.querySelectorAll('.number-input');
                inputs.forEach(input => {
                    input.setAttribute('placeholder', `请输入${minValue}-${maxValue}`);
                });
            });
        },
        resetFilters(){
            this.filters = {
                hot_count: null,
                cold_count: null,
                warm_count: null,
                sum_range: [],
                odd_even_ratio: '',
                high_low_ratio: '',
                consecutive_count: '',
                same_tail_count:''
            }
            this.currentNumbers = []
            this.$message.info('已重置所有筛选条件')
        },
        applyFilters(){
            let lotteryId;
            switch(this.lotteryType) {
                case 'ssq':
                    lotteryId = 1;
                    break;
                case 'dlt':
                    lotteryId = 3;
                    break;
                case 'fc3d':
                    lotteryId = 5;
                    break;
                default:
                    lotteryId = 1;
            }
            
            const params = {
                lottery_id: lotteryId,
                config: {
                    ...this.filters,
                    blue_ball: 'random'
                }
            };
            getRecommendNum(params).then(res => {
                console.log(res,'resssssssss')
                this.currentNumbers = res.data.data.main;
            })
        }
    }
}
</script>
<style scoped>
.historyData-container {
    max-width: 1200px;
    margin: 20px auto;
    font-family: Arial, sans-serif;
    h1{
      color: #f44336;
      text-align: center;
    }
}
.filter-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 15px;
}
.filter-group label {
    margin-bottom: 5px;
    font-weight: bold;
    font-size: 14px;
}
.filter-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
}
.ball {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: bold;
  user-select: none;
  transition: all 0.3s;
}
.ball.red, .ball.front {
  background-color: #f8f8f8;
  color: #f44336;
  border: 1px solid #f44336;
}
.ball.small {
  width: 28px;
  height: 28px;
  font-size: 12px;
}
.result-area {
  margin-top: 30px;
}

.combination-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 10px;
}

.combination-item {
  display: flex;
  align-items: center;
  padding: 5px;
  border-bottom: 1px dashed #eee;
}

/* .combo-index {
  margin-right: 10px;
  color: #666;
  width: 30px;
} */

.red-balls, .front-balls {
  display: flex;
  gap: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/usingTools/historyData.vue